import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Template } from '../../models/template';
import { DigitalCourse } from '@modules/course/digitalcourse/models';
import { DigitalCourseStoreService } from '@modules/course/digitalcourse/store/services';
import { TemplateStoreService } from '@modules/template/student/store/services/template-store.service';
import { TRANSLATION_SCOPE } from '../../i18n/scope';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'],
})
export class TemplateComponent implements OnInit {
  translationScope = TRANSLATION_SCOPE;
  digitalCourses$: Observable<DigitalCourse[]> = this.digitalCourseStore.getAllDigitalCourse();
  studentTemplates$: Observable<Template[]> = this.templateStore.getStudentTemplates();

  constructor(private digitalCourseStore: DigitalCourseStoreService, private templateStore: TemplateStoreService) {}

  ngOnInit(): void {
    // Fetch Digital Courses
    this.digitalCourseStore.fetchAllDigitalCourses({
      name: '',
      pageOffset: 0,
      pageSize: 100,
      sort: 'random',
    });
    this.templateStore.fetchAllTemplates();
  }
}
